import backgroundImage from './images/LP-Compatability-w-Blinds-top.jpg';
export const load = () => ({
	title: 'How to Use Indow Inserts with Blinds, Curtains, and Shutters',
	h1: 'Indow Inserts Work Great With Blinds And Curtains',
	showTitle: true,
	backgroundImage,
});
